import React, { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldLabel } from '@components-library/Forms/shared/FieldLabel';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import { Checkbox as AntdCheckbox, CheckboxProps as AntdCheckboxProps, CheckboxRef as AntdCheckboxRef } from 'antd';
import cn from 'classnames';
import styles from './checkbox.module.scss';

interface ICheckboxProps
  extends Pick<AntdCheckboxProps, 'indeterminate' | 'checked' | 'onClick' | 'onChange' | 'disabled' | 'className'> {
  children?: React.ReactNode;
  label?: string;
  rootClassName?: string;
  stopPropagation?: boolean;
}

export const Checkbox = React.forwardRef(
  (
    {
      onChange,
      checked,
      indeterminate,
      disabled,
      className,
      children,
      label,
      rootClassName,
      stopPropagation,
    }: ICheckboxProps,
    ref: Ref<AntdCheckboxRef>,
  ) => {
    const { i18n } = useTranslation();

    return (
      <div className={rootClassName} onClick={(e) => stopPropagation && e.stopPropagation()}>
        {label && <FieldLabel label={label} />}
        <AntdCheckbox
          ref={ref}
          onChange={onChange}
          checked={checked}
          indeterminate={indeterminate}
          disabled={disabled}
          className={cn(className, styles.checkboxWrapper, { [styles.disabled]: disabled })}>
          {typeof children === 'string' ? i18n.t(children as KeyMapKeys) : children}
        </AntdCheckbox>
      </div>
    );
  },
);
